import { AuthGuard, CrudOp, projectOverviewAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const ProjectOverview: FC = () => (
  <AuthGuard authScope={projectOverviewAuthScope} crudOp={CrudOp.READ}>
    <Suspense><LazyProjectOverview/></Suspense>
  </AuthGuard>
);

const LazyProjectOverview = lazy(importView(
  () => import("../components/ProjectOverview"),
  (it) => it.ProjectOverview,
));
